export default "__VITE_ASSET___vmV0tmp__"